'use strict';

module.exports = require('./node/');



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/index.js
// module id = 200
// module chunks = 1